exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-pie.js
// module id = 195
// module chunks = 8